import { stripHtml } from "./stripHtml";

export function buildFaqSchema(accordionBlocks = []) {
  const questions = accordionBlocks
    .filter((block) => block.heading && block.text)
    .map((block) => ({
      "@type": "Question",
      name: block.heading.trim(),
      acceptedAnswer: {
        "@type": "Answer",
        text: stripHtml(block.text),
      },
    }));

  if (questions.length === 0) return null;

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questions,
  };
}
